// noinspection JSUnresolvedVariable
import {connect} from 'react-redux'
import InfiniteScroll from 'react-infinite-scroller'
import styles from './List.css'
import {
  purchaseOrderRequest,
  onClickRow
} from 'actions/inventory/purchaseOrder'
import {getFormValues, isDirty} from 'redux-form'
import moment from 'moment'
import {rupiah} from 'utils/formatter'
import {askConfirmAction} from 'actions/confirm-action'

class List extends React.Component {
  render () {
    const {purchaseOrders, purchaseOrderDetail, search} = this.props
    let outletIds = null
    if (search) {
      outletIds = search.outletIds
    }
    const showOutlet = outletIds && outletIds.length > 1

    return ((purchaseOrders.length > 0) && <div className={styles['wrapper']}>
      <table className={styles['table-header']}>
        <thead>
          <tr>
            <th>Date</th>
            {showOutlet && <th>Outlet</th>}
            <th>Supplier</th>
            <th>Order No.</th>
            <th>Total</th>
            <th>Status</th>
          </tr>
        </thead>
      </table>
      <div className={styles['table-content-wrapper']}>
        <InfiniteScroll
          pageStart={1}
          loadMore={this._onReachBottom}
          hasMore={this._hasMore()}
          useWindow={false}
          threshold={10}
          initialLoad={false}
          >
          <table className={`${styles['table-content']}`}>
            <tbody>
              {purchaseOrders.length > 0 && purchaseOrders.map((purchaseOrder) => {
                if (purchaseOrder.isdaterow) {
                  return (<tr>
                    <td colSpan={showOutlet ? 6 : 5} className={styles.parentRow}>{moment(purchaseOrder.created_at).format('ddd MMM DD YYYY')}</td>
                  </tr>)
                } else {
                  let statusIcon = ''
                  if (purchaseOrder.status === 'Created' || purchaseOrder.status === 'Updated') { statusIcon = 'btn-warning glyphicon-plus' } else if (purchaseOrder.status === 'Fulfilled') { statusIcon = 'btn-success glyphicon-ok' } else if (purchaseOrder.status === 'Cancelled') { statusIcon = 'btn-danger glyphicon-minus' }
                  return (<tr className={`${(purchaseOrderDetail && purchaseOrder.id === purchaseOrderDetail.id) ? styles.selected : ''}`}
                    onClick={() => this._onClickRow(purchaseOrder)}>
                    <td>{moment(purchaseOrder.created_at).format('HH:mm')}</td>
                    {outletIds && outletIds.length > 1 && <td>{purchaseOrder.outlet.name}</td>}
                    <td>{purchaseOrder.supplier_name}</td>
                    <td>#{purchaseOrder.order_no}</td>
                    <td>{rupiah(purchaseOrder.total)}</td>
                    <td><i className={'glyphicon btn ' + statusIcon + ' ' + styles.icon} /><span className={styles.status}>{purchaseOrder.status}</span></td>
                  </tr>)
                }
              })}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
      </div>)
  }

  _onReachBottom = () => {
    const {currentPage, purchaseOrders, dispatch, search: {date: {startDate, endDate}, keyword, status, namespace}} = this.props
    dispatch(purchaseOrderRequest(namespace, {
      page: currentPage + 1,
      start: startDate.toString(),
      end: endDate.toString(),
      keyword,
      status
    }, purchaseOrders))
  }

  _hasMore = () => {
    const {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }

  _onClickRow = (purchaseOrder) => {
    const {dispatch, search: {namespace}, isDirtyForm} = this.props
    if (isDirtyForm) {
      dispatch(askConfirmAction(onClickRow(purchaseOrder, namespace)))
    } else {
      dispatch(onClickRow(purchaseOrder, namespace))
    }
  }
}

function mapStateToProps (state) {
  const {purchaseOrders, purchaseOrderDetail, currentPage, totalPage} = state.inventory.purchaseOrder
  return {
    purchaseOrders,
    purchaseOrderDetail,
    currentPage,
    totalPage,
    search: getFormValues('search')(state),
    isDirtyForm: isDirty('purchaseOrder')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

List.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Inventory/PurchaseOrder/List/List.js